function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import round from 'lodash/round';
export function formatRegularNumber(number, locale, _ref) {
  var delimiter = _ref.delimiter,
      separator = _ref.separator,
      precision = _ref.precision;
  var formatter = new Intl.NumberFormat(locale, {
    style: 'decimal',
    maximumFractionDigits: precision
  });
  return formatter.formatToParts(number).map(function (_ref2) {
    var type = _ref2.type,
        value = _ref2.value;

    switch (type) {
      case 'group':
        return delimiter;

      case 'decimal':
        return separator;

      default:
        return value;
    }
  }).reduce(function (s, p) {
    return s + p;
  });
} // Madness for 4-digit numbers.
// See Diccionario panhispánico de dudas ©2005: http://lema.rae.es/dpd/srv/search?id=QHaq7I8KrD6FQAyXTS
// RAE "explanation": https://twitter.com/RAEinforma/status/441873432519909376
// Referenced CGPM documents by RAE, which contradict RAE explanation:
// - Resolution 7 of the 9th CGPM (1948): https://www.bipm.org/en/CGPM/db/9/7/
// - Resolution 10 of the 22nd CGPM (2003) (reaffirms previous): https://www.bipm.org/en/CGPM/db/22/10/

export function formatRaeNumber(number, locale, _ref3) {
  var delimiter = _ref3.delimiter,
      separator = _ref3.separator,
      precision = _ref3.precision;

  if (number < -9999 || number > 9999) {
    delimiter = delimiter || '&nbsp;';
    return formatRegularNumber(number, locale, {
      delimiter: delimiter,
      separator: separator,
      precision: precision
    });
  } else {
    var _round$toString$split = round(number, precision).toString().split('.'),
        _round$toString$split2 = _slicedToArray(_round$toString$split, 2),
        integer = _round$toString$split2[0],
        decimal = _round$toString$split2[1];

    return decimal ? "".concat(integer, ",").concat(decimal) : integer;
  }
}